import { render } from "./FarmToFarmSteps.vue?vue&type=template&id=4b5a9389&ts=true"
import script from "./FarmToFarmSteps.vue?vue&type=script&lang=ts"
export * from "./FarmToFarmSteps.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__